export function buildSearchEndpoint(templateUrl, { country, page, term }) {
  const path = templateUrl
    .replace('*country*', encodeURIComponent(country))
    .replace('*page*', encodeURIComponent(String(page)))

  const params = new URLSearchParams()
  if (term) params.set('term', term)

  const query = params.toString()
  return query ? `${path}?${query}` : path
}
